<div class="video-box">
    <div class="image">
        <img src="assets/img/video-img1.jpg" class="shadow" alt="image">
    </div>
    <a href="https://www.youtube.com/watch?v=PWvPbGWVRrU" class="video-btn popup-youtube"><i class="flaticon-play"></i></a>
    <div class="shape10"><img src="assets/img/shape9.png" alt="image"></div>
</div>